import { PenLine } from "lucide-react";

export const AuthorSection = ({ content }) => {
  if (!content.author_bio) return null;

  return (
    <section id="autrice" className="paper-texture py-16 sm:py-24" data-testid="author-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="grid items-center gap-10 rounded-3xl border border-sand bg-white p-8 shadow-md sm:p-12 lg:grid-cols-[2fr_1fr]">
          <div className="space-y-5">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-terracotta">
              <PenLine className="h-4 w-4" /> Una lettera per te
            </span>
            <h2 className="font-display text-2xl font-bold tracking-tight text-olive sm:text-3xl" data-testid="author-title">
              Dall'autrice, {content.author}
            </h2>
            <p className="text-base leading-relaxed text-stone-600 sm:text-lg" data-testid="author-bio">
              {content.author_bio}
            </p>
            <div className="flex flex-wrap gap-2 pt-1" data-testid="author-credentials">
              <span className="rounded-full bg-terracotta-light px-3.5 py-1.5 text-xs font-semibold text-terracotta-dark">Esperta in intelligenza emotiva</span>
              <span className="rounded-full bg-olive-light px-3.5 py-1.5 text-xs font-semibold text-olive">Facilitatrice mindfulness</span>
            </div>
            <div className="grid gap-3 pt-2 sm:grid-cols-3" data-testid="author-projects">
              <div className="rounded-xl border-l-4 border-terracotta bg-warm p-4">
                <p className="font-display text-sm font-bold text-olive">Io Emozione</p>
                <p className="mt-1 text-xs text-stone-500">Progetto per le scuole elementari</p>
              </div>
              <div className="rounded-xl border-l-4 border-olive bg-warm p-4">
                <p className="font-display text-sm font-bold text-olive">EmoProject</p>
                <p className="mt-1 text-xs text-stone-500">Progetto per le scuole medie</p>
              </div>
              <div className="rounded-xl border-l-4 border-amazon-orange bg-warm p-4">
                <p className="font-display text-sm font-bold text-olive">Sinfonie – Accordo di Suoni</p>
                <p className="mt-1 text-xs text-stone-500">Per licei musicali e conservatori</p>
              </div>
            </div>
            <p className="font-display text-xl font-semibold italic text-terracotta">— {content.author}</p>
          </div>
          <div className="relative">
            <div className="absolute -inset-3 rotate-3 rounded-3xl bg-terracotta-light" aria-hidden />
            <img
              src="/images/metodo-emo.jpg"
              alt="MetodoEmo – un ecosistema educativo per abitare le proprie emozioni"
              className="relative rounded-3xl object-cover shadow-lg"
              data-testid="author-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
